import { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { PartialRecording } from '../../types';

export const selectPartialRecordingProps = (recording: Recording): PartialRecording => ({
  id: recording.id,
  duration: recording.duration,
  date: recording.created_epoch_time,
  watched: recording.watched,
});
